var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Preview',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Aside")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"aside"},[_c('Aside')],1)]},proxy:true},{key:"desc",fn:function(){return undefined},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }